import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/api.service';
@Component({
  selector: 'app-ranked-choice-voteing-sms',
  templateUrl: './ranked-choice-voteing-sms.component.html',
  styleUrls: ['./ranked-choice-voteing-sms.component.scss']
})
export class RankedChoiceVoteingSmsComponent implements OnInit {
  options = ['opt1','opt2','opt3'];
  options1 = {opt1:'option 1',opt2:'option 2', opt3:'option 3'};
  displayedColumns1 = ['name','option 1','option 2','option 3'];
  // tableData  = [{opt:'1 st', value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}]},
  // {opt:'2 nd', value:[{val:false ,disable:false},{val:false,disable:false},{val:false,disable:false}]},
  // {opt:'3 rd', value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}]}
  // ];
  pollMessage = '';
  hideInput = false;
  activTab;
  finalTab;
  pollOptions = [];
  preference = ['1 st', '2 nd', '3 rd','4 th','5 th', '6 th', '7th', '8 th', '9 th'];
  tableData = [];
  tableData1 = [];
  optionNameList = ['name'];
  pollResult = [];
  errorMessage;
  errorType;
  type = 'fail';
  showSpinner = false;

  constructor(private _apiService: ApiService,location: Location,
    private _snackBar: MatSnackBar) {
    this.activTab = location.path();
    this.finalTab= this.activTab.substr(this.activTab.lastIndexOf('/') + 1);
   }


  ngOnInit() {
    this.showSpinner = true;
    this._apiService.getPollInfoByUID(this.finalTab).subscribe(res => {
      this.hideInput = false;
      if (res) {
          console.log( res)
        this.pollOptions = res.poll_options;
        this.pollMessage = res.poll.message;
        if(this.pollOptions){
          let dataInsttance = {};
          for(var i=0; i< this.pollOptions.length; i++){
            this.optionNameList.push(this.pollOptions[i].name)
            let pref = this.preference[i];
            console.log(pref);
            dataInsttance['opt'] = pref;
            let valueInstance = [];
            for(var j=0; j< this.pollOptions.length; j++){
              let inst = {val:false,disable:false};
              valueInstance.push(inst);
            }
            dataInsttance['value'] = valueInstance;
            this.tableData.push(dataInsttance);
            valueInstance = [];
            dataInsttance = {};
          }
        }
        // console.log(this.tebleData1);
            this.tableData1 =JSON.parse(JSON.stringify(this.tableData));
        this.showSpinner = false;
      }
    },
    (error)=>{
      this.hideInput = true;
      this.errorMessage = error.error;
      this.errorType = error.statusText;
      this._snackBar.open('Error Occured : '+error.error, 'OK', { duration: 3000 });
      this.showSpinner = false;
    });
    
  }

  handleClick(ri,ci,event){
    if(event.currentTarget.checked){
      let disColumn=[];
      let disRow = [];
      let checkObject={};
      for (var i=0;i<this.tableData.length;i++) {
        for (var j=0;j<this.tableData[i].value.length;j++) {
          if (this.tableData[i].value[j].val) {
            disColumn.push(j);
            disRow.push(i);
            checkObject[i] = j;
          }
        }
      }
      for (var i=0;i<this.tableData.length;i++) {
        for (var j=0;j<this.tableData[i].value.length;j++) {
          if (disColumn.includes(j) || disRow.includes(i)) {
            this.tableData[i].value[j]['disable'] = true;
          }
        }
      }

    }
  }

  onSubmit(){
    this.showSpinner = true;
    for(let i=0; i<this.tableData.length; i++){
      for (var j=0;j<this.tableData[i].value.length;j++) {
        if (this.tableData[i].value[j].val == true) {
          let selectedOption = this.optionNameList[j+1];
          this.pollResult.push(selectedOption);
        }
      }
    }
    console.log('res',this.pollResult);
    let data = {};
    data["user_ranking"] =this.pollResult;
    console.log('res',data);
    this._apiService.submitVote(this.finalTab,data).subscribe(res => {
      if (res) {
        this.hideInput = true;
        this.type = 'success';
        this.errorMessage = 'Voting is successful.';
        this.errorType = 'Success';
          console.log( res)
      }
      this.showSpinner = false;
    },
    (error)=>{
      this.hideInput = true;
      this.errorMessage = error.error;
      this.errorType = error.statusText;
      this._snackBar.open('Error Occured : '+error.error, 'OK', { duration: 3000 });
      this.showSpinner = false;
    });
  }

  resetValues(){
    // this.tableData  = [{opt:'1 st',level: 1,id:1,value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}],column:'option 1' },
    // {opt:'2 nd',level: 2,id:2,value:[{val:false ,disable:false},{val:false,disable:false},{val:false,disable:false}],column:'option 1' },
    // {opt:'3 rd',level: 3,id:3,value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}],column:'option 1' }];

    // this.tableData  = [{opt:'1 st', value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}]},
    // {opt:'2 nd', value:[{val:false ,disable:false},{val:false,disable:false},{val:false,disable:false}]},
    // {opt:'3 rd', value:[{val:false,disable:false},{val:false,disable:false},{val:false,disable:false}]}
    // ];
    this.tableData = this.tableData1;
    this.tableData1 =JSON.parse(JSON.stringify(this.tableData));
  }
}

